import { render, staticRenderFns } from "./ReceiptNoDalog.vue?vue&type=template&id=2a4b19ac&scoped=true&"
import script from "./ReceiptNoDalog.vue?vue&type=script&lang=js&"
export * from "./ReceiptNoDalog.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptNoDalog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReceiptNoDalog.vue?vue&type=style&index=1&id=2a4b19ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b19ac",
  null
  
)

export default component.exports